import { render, staticRenderFns } from "./show_optional.vue?vue&type=template&id=0b604f9f&scoped=true&"
import script from "./show_optional.vue?vue&type=script&lang=js&"
export * from "./show_optional.vue?vue&type=script&lang=js&"
import style0 from "./show_optional.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./show_optional.vue?vue&type=style&index=1&id=0b604f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b604f9f",
  null
  
)

export default component.exports